import { schema } from 'normalizr'

const CommonTypeSchema = new schema.Entity('commonTypes')

export default CommonTypeSchema
